import React from 'react';

export function NexusTable({ columns = [], rows = [], renderRow }) {
  return (
    <div className="table-wrap">
      <table>
        <thead>
          <tr>{columns.map(column => <th key={column.key || column}>{column.label || column}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((row, index) => renderRow(row, index))}
        </tbody>
      </table>
    </div>
  );
}
